// src/hooks/useProfesoresAFormar.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";

export interface ProfesorFormable {
  id: number;
  nombre: string;
}

export function useProfesoresAFormar(idAsignatura: number | "") {
  return useQuery<ProfesorFormable[]>({
    queryKey: ["profesores-a-formar", idAsignatura],
    enabled: !!idAsignatura,
    queryFn: async () => {
      const { data } = await api.get(`/formaciones/recipientes/${idAsignatura}`);
      return data;
    },
  });
}
